<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Hierarquia' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content padding>
  <div class="gradient-extendido"></div>

  <div class="list-funcoes">
    <ion-grid *ngFor="let list of hierarquiaList">
      <div *ngFor="let hierarquia of list.funcoes">
        <ion-row *ngIf="hierarquia.hierarquiaGrupoFuncao" (click)="selecionarHierarquia(hierarquia)">
          <ion-col size="2">
            <ion-avatar>
              <img
                [src]="hierarquia.hierarquiaGrupoFuncao.pessoa.foto | image:' '"
              />
            </ion-avatar>
          </ion-col>

          <ion-col size="8" class="info-col">
            <ion-label>
              <h5
                *ngIf="hierarquia.hierarquiaGrupoFuncao.pessoa"
                class="item-title bold-2"
              >
                {{hierarquia.hierarquiaGrupoFuncao.pessoa.nome}}
              </h5>

              <div class="item-description">
                <p class="description-text bold-1">{{hierarquia.nome}}</p>
              </div>
            </ion-label>
          </ion-col>

          <ion-col size="2" class="icon-col" *ngIf="!userProvider.hasConfig(241)">
            <ion-note>
              <ion-icon class="icon-list" name="ellipsis-vertical"></ion-icon>
            </ion-note>
          </ion-col>

          <ion-item-divider></ion-item-divider>
        </ion-row>


        <ion-row
          *ngIf="!hierarquia.hierarquiaGrupoFuncao"
          (click)="selecionarHierarquiaNova(hierarquia)"
        >
          <ion-col size="10">
            <ion-label>
              <h5 class="item-title bold-2">{{'Não Informado' | translate}}</h5>

              <div class="item-description">
                <p class="description-text bold-1">{{hierarquia.nome}}</p>
              </div>
            </ion-label>
          </ion-col>

          <ion-col>
            <ion-note>
              <ion-icon name="ellipsis-vertical" class="icon-list"></ion-icon>
            </ion-note>
          </ion-col>
        </ion-row>
      </div>
    </ion-grid>
  </div>
</ion-content>
